import React from 'react';
import { Skeleton } from '@progress/kendo-react-indicators';

interface Props {
  className?: string;
}

export default function SkeletonButton({ className }: Props) {
  return (
    <Skeleton
      shape="rectangle"
      className={className}
      style={{ height: 32, width: '100%' }}
    />
  );
}
